import React from 'react';

export const G2Tag = ({ className }) => {
  const ICON_STAR = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
    >
      <path
        d="M7.50659 0.0495605L9.3609 4.50783L14.174 4.8937L10.5069 8.03492L11.6273 12.7317L7.50659 10.2148L3.38593 12.7317L4.50627 8.03492L0.839212 4.8937L5.65229 4.50783L7.50659 0.0495605Z"
        fill="#212BC4"
      />
    </svg>
  );

  return (
    <div className={className}>
      <a
        href="https://www.g2.com/products/alloy-alloy-automation/reviews"
        target="_blank"
        rel="nofollow noreferrer"
      >
        <div className="flex items-center justify-center gap-2 rounded-full border border-black/10 bg-white p-4 transition-smooth hover:bg-azure-100">
          <img
            src="https://cdn.runalloy.com/landing/2025/g2-logo.svg"
            alt="g2"
            className="h-10 w-10"
          />
          <div className="text-azure-900">
            <p className="mb-0 text-[13px] font-semibold tracking-[0.26px]">
              Read our reviews on G2
            </p>
            <div className="flex items-end">
              <span className="text-[15px] font-bold">5</span>&nbsp;
              <span className="text-[13px] font-normal">out of 5 stars</span>
              <div className="my-0.5 ml-2 flex items-center gap-0.5">
                {ICON_STAR}
                {ICON_STAR}
                {ICON_STAR}
                {ICON_STAR}
                {ICON_STAR}
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};
